// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.math.sign.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.math.sign.js
// module chunks = 0